import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  listOrders: [],
  originListOrders: [], // TO HOLD ORIGIN DATA
  inboundSerial: '',
}

const slice = createSlice({
  name: 'inboundPreOrder',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    setListOrders(state, action) {
      state.isLoading = false;
      state.listOrders = action.payload;
    },

    setOriginListOrders(state, action) {
      state.isLoading = false;
      state.originListOrders = action.payload;
    },

    setInboundSerial(state, action) {
      state.isLoading = false;
      state.inboundSerial = action.payload;
    },

    resetListOrders(state) {
      state.listOrders = [];
      state.originListOrders = [];
      state.inboundSerial = '';
    }
  }
})

// Reducer
export default slice.reducer;

// Actions
export const {
} = slice.actions;

export function setListOrders(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setListOrders(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setOriginListOrders(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setOriginListOrders(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setInboundSerial(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setInboundSerial(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function resetListOrders(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.resetListOrders(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}